import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import { Card, CardContent, Typography } from "@material-ui/core";
import { VisitorHistoryList } from "./VisitorHistoryList";
import { ActiveVisitorList } from "./ActiveVisitorList";
import { VisitorLineChart } from "./VisitorLineChart";
import { combineProps } from "../../../../helpers/objectHelper";
import EventLabel2 from "../../../../components/EventLabel2/EventLabel2";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    boxShadow: "none",
    height: "100%",
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  title: {
    fontSize: 14,
    padding: "10px 15px",
  },
  grid: {
    padding: theme.spacing(3),
  },
}));

export default function Dashboard(props) {
  const classes = useStyles();
  const { peopleFilter, toggleFilter } = props;
  return (
    <div className={classes.root}>
      <Grid container spacing={3} className="grid-container">
        <Grid item xs={12} sm={12} className="floating-grid">
          <Paper className={classes.paper + " blueish-shadow data-chart"}>
            <VisitorLineChart graphData={props.graphData} />
          </Paper>
        </Grid>
      </Grid>
      <Grid container spacing={3} className="bottom-grid-list">
        <Grid item xs={12} sm={12} md={8} lg={8} className="contained-grid">
          <Card className={classes.root} style={{ paddingLeft: 20, borderRight: "1px solid gainsboro" }}>
            <CardContent className="flex-list">
              <div style={{ margin: "15px 0px" }}>
                <span onClick={toggleFilter} className={"expo-title tab-btn" + (peopleFilter == "ATTENDEES" ? " active" : "")}>
                  <EventLabel2 name="VisitorsRightNow" groupName="Exhibitor.Admin" />
                </span>
                <span onClick={toggleFilter} className={"expo-title tab-btn" + (peopleFilter == "EXHIBITORS" ? " active" : "")}>
                  <EventLabel2 name="Staff" groupName="Exhibitor.Admin" />
                </span>
              </div>

              <ActiveVisitorList {...props} />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={4} className="contained-grid">
          <Card className={classes.root}>
            <CardContent className="flex-list">
              <span className={"expo-title"}>
                <EventLabel2 name="HasVisited" groupName="Exhibitor.Admin" />
              </span>
              <VisitorHistoryList {...props} />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
}
